@if (groupItems() && groupItems().length) {
  <div class="mt-8">
    <h2>{{ 'common.order.groupItems' | actrans }}</h2>
    @for (g of groupItems(); track g.id) {
      <div nz-row [nzGutter]="16" class="mt-1">
        <div nz-col [nzSpan]="12">
          {{ g.relatedProductName }}
        </div>
        <div nz-col [nzSpan]="12" class="text-right">
          <nz-input-number
            [ngModel]="g.quantity"
            (ngModelChange)="updateQuantity(g.id, $event)"
            [nzMin]="0"
            [nzStep]="1">
          </nz-input-number>
          @if (g.amount != null) {
            <span class="ml-1">{{ g.amount | nf }}</span>
          }
        </div>
      </div>
    }
  </div>
}
